import React from "react";
import BankAccounts from "@/pages/admin/BankAccounts";
import { useAuth } from "@/context/AuthContext";

export default function InstituteBanks() {
  const { role, user } = useAuth();
  const writable = role === "institute_admin";
  return (
    <div data-testid="institute-portal-banks">
      <BankAccounts
        apiBase="/institute/banks"
        title="Bank Accounts"
        subtitle={user?.institute_name ? `Institute · ${user.institute_name}` : "Institute"}
        intro="Bank accounts operated by your institute. Capture Maker / Checker / Approver signatories for each account."
        signatoryMode="mca"
        writableOverride={writable}
      />
    </div>
  );
}
